// basePath('/v2') 때문에 BFF 라우트는 `/v2/api/...`에서만 매칭된다. clientHttp의 baseURL은
// 운영 빌드에서 `''`라 `/api/...`로 부르면 ingress가 백엔드로 바로 보내 BFF를 건너뛴다.
// 그래서 운영에서는 경로에 `/v2`를 직접 붙인다.
export const getApiPath = (path: string) =>
  process.env.NODE_ENV === 'production' ? `/v2${path}` : path
